import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import {
  Checkbox,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  Button,
  Typography,
  MenuItem,
  Select,
  Input,
  ListItemText,
  CircularProgress,
  IconButton,
  Chip,
  InputLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import applovinLogo from "../../images/network/IconsThin/applovin-icon.png";
import facebookLogo from "../../images/network/IconsThin/facebook-icon.png";
import googleLogo from "../../images/network/IconsThin/googleads-icon.png";
import ironsourceLogo from "../../images/network/IconsThin/ironsource-icon.png";
import mintegralLogo from "../../images/network/IconsThin/mintegral-icon.png";
import unityLogo from "../../images/network/IconsThin/unityads-icon.png";
import vungleLogo from "../../images/network/IconsThin/vungle-icon.png";
import tiktokLogo from "../../images/network/IconsThin/tiktok-icon.png";
import molocoIcon from "../../images/network/IconsThin/moloco-icon.png";
import appgrowthIcon from "../../images/network/IconsThin/appgrowth-icon.png";
import DownloadIcon from "@mui/icons-material/Download";
import { getServerUri } from "../modules/uriUtility";
import { incrementCompanyUsage } from "../modules/companySubscriptionApi";
import { calculateVersionPlayableSize, MAX_PLAYABLE_SIZE_BYTES } from "../modules/playableSizeCalculator";
import DialogDropboxSubmit from "./dialogDropboxSubmit";
import DialogPlayableSizeWarning from "./dialogPlayableSizeWarning";
import {
  deliversToDropbox,
  dropboxDestination,
  noFolderCancelledMessage,
  resolveExportGameTitle,
  usesGameTitleInExportNaming,
} from "../modules/buildProfileUtils";
import _ from "lodash";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ArrowRightRoundedIcon from "@material-ui/icons/ArrowRightRounded";
import ArrowLeftRoundedIcon from "@material-ui/icons/ArrowLeftRounded";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/system";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
const networkViews = [
  { name: "applovin", logo: applovinLogo, caption: "AppLovin" },
  { name: "facebook", logo: facebookLogo, caption: "Facebook" },
  { name: "google", logo: googleLogo, caption: "Google" },
  { name: "ironsource", logo: ironsourceLogo, caption: "IronSource" },
  { name: "mintegral", logo: mintegralLogo, caption: "Mintegral" },
  { name: "unity", logo: unityLogo, caption: "Unity" },
  { name: "liftoff", logo: vungleLogo, caption: "Liftoff" },
  { name: "tiktok", logo: tiktokLogo, caption: "Tiktok" },
  { name: "moloco", logo: molocoIcon, caption: "Moloco" },
  { name: "appgrowth", logo: appgrowthIcon, caption: "AppGrowth" },

];

const useStyles = makeStyles(() => ({
  networkLogo: { height: 20 },
  networkDiv: { display: "flex", alignItems: "center", padding: "2px 10px 2px 0px" }, //#9bcec0
  versionSelector: {
    width: "100%",
    fontSize: "large",
    fontFamily: "Helvetica",
    color: "#eeeeee",
    "&:before": {
      "borderBottom": "1px solid #676767 !important",
    },
    "&:hover:not(.Mui-disabled):before": {
      "borderBottom": "2px solid #ffffff !important",
    },
  },
  inputLabel: { fontSize: "14px", color: "#9bcec0" },
  downloadDialogCard: {
    margin: "0px 30px 15px 30px",
    padding: 0,
    width: 440,
    backgroundColor: "#363636",
    color: "#eeeeee",
    borderRadius: "10px",
  },
  dialogTitle: { textAlign: "center", fontSize: "100px", fontFamily: "Helvetica" },
  htmlCreditTypography: { width: "146.6px" },
  dialogStyle: { borderRadius: "10px" },
  loadingIcon: {
    width: 400,
    height: 500,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "inherit",
  },
  versionNameWrapper: {
    flex: 1,
    overflowX: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    paddingRight: "10px",
  },
  versionNameListItem: {
    display: "inline-block",
    minWidth: "100%",
    whiteSpace: "nowrap",
    backgroundColor: "transparent",
    color: "#eeeeee",
    fontFamily: "Helvetica",
  },
  hiddenVersionNameMeasure: {
    position: "absolute",
    visibility: "hidden",
    whiteSpace: "nowrap",
    pointerEvents: "none",
    fontFamily: "Helvetica",
    fontSize: "15px",
  },
  versionMenuPaper: {
    overflowX: "auto",
    width: 260,
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    backgroundColor: "#4b4b4b",
  },
}));

const DOWNLOAD_ERROR_MESSAGE = "Error During Downloading HTMLs";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

/**
 *
 * @param props.open
 * @param props.isOpen
 * @param props.onClose
 * @param props.selectedVersion
 * @param props.selectedBase
 * @param props.setIsDownloadingPlayable
 * @returns {JSX.Element}
 */
export default function dialogMultipleVersionDownload(props) {
  const [selectedLanguagesSet, setSelectedLanguagesSet] = useState(new Set());

  const [isBuilding, setIsBuilding] = useState(false);
  const [buttonText, setButtonText] = useState("Download");
  const [error, setError] = useState("");
  const [selectedVersions, setSelectedVersions] = useState([]);
  const [versionNames, setVersionNames] = useState([]);
  const [selectedVersionsInfos, setSelectedVersionsInfos] = useState([
    { versionID: props.selectedVersion?._id, languages: ["en"], networks: [] },
  ]);
  const [maxVersionNameWidth, setMaxVersionNameWidth] = useState(0);
  const [versionSizes, setVersionSizes] = useState([]);
  let [currentVersion, setCurrentVersion] = useState({});
  let [versionIndex, setVersionIndex] = useState(0);
  let [currentPlayableCount, setCurrentPlayableCount] = useState(0);
  let [htmlCount, setHtmlCount] = useState(0);
  let [creditLeft, setCreditLeft] = useState(currentPlayableCount);
  let [downloadedVersionCount, setDownloadedVersionCount] = useState(0);
  let [downloadedHTMLCount, setDownloadedHTMLCount] = useState(0);
  let [ETAMinutes, setETAMinutes] = useState(0);
  let [languagesLoaded, setLanguagesLoaded] = useState(false);
  let [allVersionsAdded, setAllVersionsAdded] = useState(false);
  let [loadingCompleted, setLoadingCompleted] = useState(false);
  let [allLanguagesSelected, setAllLanguagesSelected] = useState(false);
  let [bundleLang, setBundleLang] = useState(false);
  const [sizeWarningVersions, setSizeWarningVersions] = useState([]);
  const [gameTitleOverride, setGameTitleOverride] = useState("");

  const versionNameRefs = useRef({});
  const versionNameMeasureRef = useRef(null);
  const classes = useStyles();
  const supportsLangBundle = Boolean(_.get(props, "userCompany.bundleLanguage", false));
  const buildProfileData = props.userCompany?.buildProfileData;
  // Submitting is its own action, confirmed each time: a download can be
  // thrown away, a file in the client's Dropbox cannot. The batch carries the
  // destination from the button down to each version's upload rather than
  // keeping it in state, so a second press cannot pick up the first's answer.
  const [isSubmitConfirmOpen, setIsSubmitConfirmOpen] = useState(false);
  // The size warning interrupts a download that was already headed somewhere;
  // resuming it must not quietly turn a submit into a plain download.
  const [sizeWarningToDropbox, setSizeWarningToDropbox] = useState(false);
  const [sizeWarningFolder, setSizeWarningFolder] = useState("");
  const canDeliverDropbox = deliversToDropbox(buildProfileData);
  const isGameTitleEditable = usesGameTitleInExportNaming(buildProfileData);
  const exportGameTitle = resolveExportGameTitle(buildProfileData, gameTitleOverride, props.selectedGame?.title);

  useEffect(() => {
    if (props.isOpen) setGameTitleOverride(props.selectedGame?.title || "");
  }, [props.isOpen, props.selectedGame?.title]);
  const menuProps = {
    PaperProps: {
      className: classes.versionMenuPaper,
      style: {
        maxHeight: ITEM_HEIGHT * 15 + ITEM_PADDING_TOP,
        width: 260,
      },
    },
  };

  const registerVersionNameRef = (key) => (element) => {
    if (element) {
      versionNameRefs.current[key] = element;
    } else {
      delete versionNameRefs.current[key];
    }
  };

  const syncVersionNameScroll = (event) => {
    const scrollLeft = event.target.scrollLeft;
    Object.keys(versionNameRefs.current).forEach((key) => {
      const ref = versionNameRefs.current[key];
      if (ref && ref !== event.target && ref.scrollLeft !== scrollLeft) {
        ref.scrollLeft = scrollLeft;
      }
    });
  };

  const longestVersionName = useMemo(() => {
    return versionNames.reduce((longest, version) => {
      const currentName = version?.versionName || "";
      if (currentName.length > longest.length) {
        return currentName;
      }
      return longest;
    }, "");
  }, [versionNames]);

  useLayoutEffect(() => {
    if (!versionNameMeasureRef.current) return;
    const width = versionNameMeasureRef.current.offsetWidth;
    if (width > 0 && width !== maxVersionNameWidth) {
      setMaxVersionNameWidth(width);
    }
  }, [longestVersionName, props.isOpen, maxVersionNameWidth]);
  const darkTheme = createTheme({
    palette: {
      mode: "dark",
      primary: { main: "#4eabb1" },
    },
  });

  const StyledChip = styled(Chip)(() => ({
    borderRadius: "3px",
    width: "325px",
    borderWidth: "thin",
    borderColor: "#676767",
    height: "70px",
    fontSize: "20px",
    lineHeight: "23px",
    color: "#eeeeee",
    "& .MuiChip-label": {
      whiteSpace: "normal",
      maxWidth: "325px",
      overflow: "visible",
      wordWrap: "break-word",
      display: "block",
      textAlign: "center",
    },
  }));

  const StyledDopDownIcon = styled(ArrowDropDownRoundedIcon)(() => ({
    fontSize: "35px",
    "&. MuiSelect-icon": {
      "top": "0px",
    },
  }));

  const StyledDialogTitle = styled(DialogTitle)({
    textAlign: "center",
    color: "#eeeeee",
    marginTop: "3px",
    "& .MuiTypography-h6": {
      fontSize: "24px",
      fontFamily: "Helvetica",
    },
  });

  const StyledButton = styled(Button)({
    fontSize: "20px",
    backgroundColor: "#418989",
    width: "190px",
    height: "60px",
    lineHeight: "23px",
    fontFamily: "Helvetica",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#579488",
    },
  });

  // Deliberately smaller and flatter than StyledButton: submitting is the rarer
  // action of the two and should not compete with Download for the eye.
  const SubmitButton = styled(Button)({
    fontSize: "13px",
    color: "#9bcec0",
    borderColor: "#5d7c76",
    textTransform: "none",
    marginTop: "8px",
    padding: "2px 14px",
  });

  const incrementHTMLDownloadedCount = (step = 1) => {
    setDownloadedHTMLCount((prevDownloadedHTMLCount) => {
      if (prevDownloadedHTMLCount >= htmlCount) return prevDownloadedHTMLCount;
      const currentValue = Math.min(prevDownloadedHTMLCount + step, htmlCount);
      setETAMinutes(() => {
        const value = Math.ceil(((htmlCount - currentValue) * 12) / 60);
        return value > 0 ? value : 1;
      });
      return currentValue;
    });
  };

  useEffect(() => {
    selectedVersionLanguagesFunction();
  }, [props.localizationLanguage]);

  useEffect(() => {
    getVersionNames();
    getCurrentPlayableCount(props.userCompany);
  }, []);

  useEffect(() => {
    let newVersionSizes = [...versionSizes];

    let versionSizeInfo = newVersionSizes.filter(
      (versionSize) => versionSize.versionID === props.selectedVersion?._id
    )[0];
    if (versionSizeInfo) {
      const index = newVersionSizes.indexOf(versionSizeInfo);

      newVersionSizes[index] = { versionID: props.selectedVersion?._id, size: props.totalSizeValue };
    } else {
      newVersionSizes.push({ versionID: props.selectedVersion?._id, size: props.totalSizeValue });
    }
    setVersionSizes(newVersionSizes);

    setLanguagesLoaded(false);
  }, [props.selectedVersion, props.totalSizeValue]);

  useEffect(() => {
    getCurrentSelectedVersionLanguageInfos();

    if (languagesLoaded && props.totalSizeValue > 0 && allVersionsAdded) {
      setLoadingCompleted(true);
    }
  }, [languagesLoaded, props.totalSizeValue, allVersionsAdded]);

  useEffect(() => {
    getVersionNames();
  }, [props.selectedVersion, props.versions, props.versionUpdate, props.versionRename]);

  useEffect(() => {
    let selectedVersionsInfo = [...selectedVersionsInfos];

    const currentVersionSelectedLanguages = selectedVersionsInfo.filter(
      (version) => version.versionID == selectedVersions[versionIndex]
    )[0]?.languages;
    const newSelectedLanguagesSet = currentVersionSelectedLanguages
      ? new Set(currentVersionSelectedLanguages)
      : new Set(selectedLanguagesSet);

    setSelectedLanguagesSet(new Set());

    if (!newSelectedLanguagesSet.has("en")) {
      newSelectedLanguagesSet.add("en");
    }

    setSelectedLanguagesSet(newSelectedLanguagesSet);

    getSelectedVersion();
    selectedVersionLanguagesFunction();
    selectedVersionNetworksFunction();
  }, [versionIndex]);

  function getVersionNames() {
    setVersionNames([]);

    if (props.versions.length > 0) {
      let allVersionNames = [];

      props.versions.forEach((version) => {
        if (props.selectedVersion?._id == version._id) {
          setSelectedVersions([version._id]);
          setCurrentVersion({ versionName: version.title, key: version._id });
        }

        allVersionNames.push({ versionName: version.title, key: version._id });
      });
      setVersionNames(allVersionNames);
      setAllVersionsAdded(true);
    }
    setSelectedVersionsInfos([{ versionID: props.selectedVersion?._id, languages: ["en"], networks: [] }]);
    //
    // getSelectedVersionName();
    // setVersionIndex(0);
  }

  async function getVersionSizes(version) {
    if (_.isNil(version)) return;

    const { totalSize } = await calculateVersionPlayableSize(
      version,
      props.selectedBase,
      _.get(props.selectedBase, "assetEnabledByComponent")
    );

    setVersionSizes((previousVersionSizes) => {
      if (previousVersionSizes.some((versionSize) => versionSize.versionID === version._id)) {
        return previousVersionSizes;
      }
      return [...previousVersionSizes, { versionID: version._id, size: totalSize }];
    });
  }

  function getCurrentVersionSize() {
    const size = versionSizes.filter(
      (versionSizeInfo) => versionSizeInfo.versionID == selectedVersions[versionIndex]
    )[0]?.size;

    const calculatedSize = parseFloat((size / 1024 / 1024).toFixed(2));

    return "Estimated Size : " + calculatedSize + " MB";
  }

  function changeNetwork(newValue) {
    let selectedVersionsInfo = [...selectedVersionsInfos];

    const currentVersionSelectedNetworks = selectedVersionsInfo.filter(
      (version) => version.versionID == selectedVersions[versionIndex]
    )[0];

    const newTotalNetwork = new Set(currentVersionSelectedNetworks?.networks);

    newValue.forEach((value) => {
      if (!newTotalNetwork.has(value)) {
        newTotalNetwork.add(value);
      }
    });

    const difference = [...newTotalNetwork].filter((network) => !newValue.some((value) => value === network))[0];

    newTotalNetwork.delete(difference);

    for (let i = 0; i < selectedVersionsInfo.length; i++) {
      if (selectedVersionsInfo[i].versionID == selectedVersions[versionIndex]) {
        const selectedVersion = {
          versionID: selectedVersions[versionIndex],
          languages: selectedVersionsInfo[i]?.languages,
          networks: Array.from(newTotalNetwork),
        };

        selectedVersionsInfo[i] = selectedVersion;
      }
    }

    setSelectedVersionsInfos(selectedVersionsInfo);

    getHtmlCount(selectedVersionsInfo);
  }

  function selectedVersionNetworksFunction() {
    let networkArray = [];

    networkViews.map((network) => {
      networkArray.push({
        "caption": network.caption,
        "name": network.name,
      });
    });

    return networkArray;
  }

  function getSelectedVersion() {
    const selectedVersion = selectedVersions[versionIndex];

    const selectedVersionInfo = versionNames.filter((version) => version.key == selectedVersion)[0];

    setCurrentVersion(selectedVersionInfo);
  }

  function defaultLanguage() {
    const languages = selectedVersionsInfos.filter(
      (selectedVersionInfo) => selectedVersionInfo.versionID == selectedVersions[versionIndex]
    )[0]?.languages;
    const languageInfo = Object.entries(props.selectedBase.supportedLanguages).filter(
      ([key]) => languages[0] == key
    )[0];

    return languageInfo ? languageInfo[1] : "";
  }

  function selectedVersionLanguagesFunction() {
    let newSelectedLanguages = [];

    const selectedVersionInfo = props.versions.filter((version) => version?._id == selectedVersions[versionIndex])[0];

    const selectedVersionLanguages = selectedVersionInfo?.createdLanguages;

    if (selectedVersionLanguages && selectedVersionLanguages.length > 0) {
      selectedVersionLanguages.forEach((languageKey) => {
        const languageInfo = Object.entries(props.selectedBase.supportedLanguages).filter(
          ([key]) => languageKey == key
        )[0];

        newSelectedLanguages.push({ key: languageInfo[0], title: languageInfo[1] });
      });
    }

    return newSelectedLanguages;
  }

  function selectLanguages(newValue, bundle = bundleLang) {
    let selectedVersionsInfo = [...selectedVersionsInfos];

    const currentVersionSelectedLanguages = selectedVersionsInfo.filter(
      (version) => version.versionID == selectedVersions[versionIndex]
    )[0]?.languages;
    const newSelectedLanguagesSet = new Set(currentVersionSelectedLanguages);

    let newSelectedLanguages = [];
    newValue.forEach((value) => {
      if (!newSelectedLanguagesSet.has(value)) {
        newSelectedLanguagesSet.add(value);
      }

      newSelectedLanguages.push(value);
    });

    for (let item in newSelectedLanguagesSet) {
      const hasIncludeItem = newValue.filter((value) => value != item).length;
      if (hasIncludeItem == 0) {
        newSelectedLanguagesSet.delete(item);
      }
    }

    setSelectedLanguagesSet(newSelectedLanguagesSet);

    for (let i = 0; i < selectedVersionsInfo.length; i++) {
      if (selectedVersionsInfo[i].versionID == selectedVersions[versionIndex]) {
        const newSelectedVersion = {
          versionID: selectedVersions[versionIndex],
          languages: newSelectedLanguages,
          networks: selectedVersionsInfo[i]?.networks,
        };

        selectedVersionsInfo[i] = newSelectedVersion;
      }
    }

    setSelectedVersionsInfos(selectedVersionsInfo);

    getHtmlCount(selectedVersionsInfo, bundle);
  }

  function getCurrentSelectedVersionNetworkInfos() {
    let selectedVersionInfo = [...selectedVersionsInfos];

    const currentVersionSelectedNetworks = selectedVersionInfo?.filter(
      (version) => version.versionID == selectedVersions[versionIndex]
    )[0]?.networks;

    let newSelectedNetworks = [];
    currentVersionSelectedNetworks?.forEach((networkKey) => {
      const networkInfo = networkViews.filter((network) => networkKey == network.name)[0];

      newSelectedNetworks.push(networkInfo.name);
    });

    return newSelectedNetworks;
  }

  function getCurrentSelectedVersionLanguageInfos() {
    let selectedVersionsInfo = [...selectedVersionsInfos];

    const currentVersionSelectedLanguages = selectedVersionsInfo.filter(
      (version) => version.versionID == selectedVersions[versionIndex]
    )[0]?.languages;

    if (!languagesLoaded) {
      if (currentVersionSelectedLanguages && currentVersionSelectedLanguages.length > 0) {
        setLanguagesLoaded(true);
      }
    }

    return currentVersionSelectedLanguages ? currentVersionSelectedLanguages : [];
  }

  function getHtmlCount(selectedVersionsInfo, bundle = bundleLang) {
    let totalHtmlCount = 0;

    selectedVersionsInfo.forEach((version) => {
      const languages = version.languages?.length;
      const networks = version.networks?.length;

      totalHtmlCount += bundle ? networks : languages * networks;
    });

    setHtmlCount(totalHtmlCount);
    // a html build takes 12 seconds approximately
    setETAMinutes(() => Math.ceil((totalHtmlCount * 12) / 60));
    // setETAMinutes((prevETAMinutes) => {
    //   console.log("enters here ETAMinutes", prevETAMinutes);
    //   return prevETAMinutes;
    // });
    getCreditLeft(totalHtmlCount);
  }

  function getCreditLeft(totalHtmlCount) {
    setCreditLeft(currentPlayableCount - totalHtmlCount);
  }

  function toggleBundleLang(checked) {
    setBundleLang(checked);

    if (checked) {
      const allLanguages = selectedVersionLanguagesFunction().map((language) => language.key);
      setAllLanguagesSelected(true);
      selectLanguages(allLanguages, checked);
    } else {
      getHtmlCount(selectedVersionsInfos, checked);
    }
  }

  /**
   * Everything that has to be true before a build starts, reported the way
   * the Download button has always reported it.
   *
   * Shared with Submit so the two refuse for the same reasons at the same
   * moment: asking "send to Dropbox?" about an export that cannot be built
   * is a question nobody can answer usefully. The oversize warning is NOT
   * here — it interrupts rather than refuses, so it belongs after the
   * person has said where the export is going.
   */
  function canStartExport() {
    let downloadingMonthlyCreatedPlayableCount = 0;
    // Bundled languages produce a single HTML per network, so only the network count is consumed.
    if (selectedVersionsInfos.length == 1) {
      downloadingMonthlyCreatedPlayableCount = bundleLang
        ? selectedVersionsInfos[0].networks.length
        : selectedVersionsInfos[0].networks.length * selectedVersionsInfos[0].languages.length;
    } else {
      selectedVersionsInfos.forEach((version) => {
        downloadingMonthlyCreatedPlayableCount += bundleLang
          ? version.networks.length
          : version.networks.length * version.languages.length;
      });
    }

    const downloadedHtmlLimit = props.userCompany.downloadHtmlLimit;

    if (downloadingMonthlyCreatedPlayableCount > downloadedHtmlLimit) {
      props.createSnackbar(`Downloadable html limit is ${downloadedHtmlLimit}`, "warning");
      return false;
    }

    if (
      props.userCompany.subscription.periods[props.userCompany.subscription.periods.length - 1]
        .monthlyCreatedPlayables +
      downloadingMonthlyCreatedPlayableCount >
      props.plans[props.getPlanIndex(props.userCompany.subscription.currentPlan)].numberOfPlayables
    ) {
      props.createSnackbar(
        `Your company's current plan allows up to ${props.plans[props.getPlanIndex(props.userCompany.subscription.currentPlan)].numberOfPlayables
        } playables`,
        "warning"
      );
      return false;
    }

    let networkErrorArray = [];
    let languageErrorArray = [];
    selectedVersionsInfos.forEach((selectedVersionInfo) => {
      if (selectedVersionInfo.networks.length == 0) {
        const versionName = props.versions.filter((version) => version._id == selectedVersionInfo.versionID)[0]?.title;
        networkErrorArray.push(versionName);
      }
      if (selectedVersionInfo.languages.length == 0) {
        const versionName = props.versions.filter((version) => version._id == selectedVersionInfo.versionID)[0]?.title;
        languageErrorArray.push(versionName);
      }
    });

    const hasNetworksEmpty = selectedVersionsInfos.some((version) => version.networks.length == 0);
    const hasLanguagesEmpty = selectedVersionsInfos.some((version) => version.languages.length == 0);

    if (hasNetworksEmpty) {
      setError("Select network for all versions");
      return false;
    }
    if (hasLanguagesEmpty) {
      setError("No languages were selected.");
      return false;
    }
    setError(null);
    return true;
  }

  function downloadGame(toDropbox = false, dropboxFolder = "") {
    if (!canStartExport()) return;

    const oversizedVersions = getOversizedVersions();
    if (oversizedVersions.length > 0) {
      setSizeWarningToDropbox(toDropbox);
      setSizeWarningFolder(dropboxFolder);
      setSizeWarningVersions(oversizedVersions);
      return;
    }

    startDownload(toDropbox, dropboxFolder);
  }

  function getOversizedVersions() {
    return selectedVersions
      .map((versionID) => {
        const sizeInfo = versionSizes.filter((versionSize) => versionSize.versionID === versionID)[0];
        const versionName = versionNames.filter((versionName) => versionName.key === versionID)[0]?.versionName;
        return { versionID, versionName, size: sizeInfo?.size || 0 };
      })
      .filter((version) => version.size >= MAX_PLAYABLE_SIZE_BYTES);
  }

  function startDownload(toDropbox = false, dropboxFolder = "") {
    setIsBuilding(true);
    setButtonText("Building...");
    console.info("sending download request");

    props.setIsDownloadingPlayable(true);

    downloadPlayableOrdered(0, toDropbox, dropboxFolder);
  }

  function resetDownloadVersionSettings() {
    setSelectedVersions([props.selectedVersion?._id]);
    setCurrentVersion({ versionName: props.selectedVersion?.title, key: props.selectedVersion?._id });
    setVersionIndex(0);
    const selectedVersionInfoUpdate = [{ versionID: props.selectedVersion?._id, languages: ["en"], networks: [] }];
    setDownloadedVersionCount(() => 0);
    setDownloadedHTMLCount(() => 0);
    setETAMinutes(() => 0);
    setSelectedVersionsInfos(selectedVersionInfoUpdate);
    setHtmlCount(0);
    setBundleLang(false);
    setAllLanguagesSelected(false);
  }

  function arrowButtonsVisibility(direction) {
    if (direction == "left") {
      return versionIndex > 0;
    } else {
      return versionIndex < selectedVersions.length - 1;
    }
  }

  /**
   *
   * @param buildsToDo
   * @param baseDir
   * @param timeStamp
   * @param version
   * @param versionName
   * @param onCompleteCallback
   */
  function buildGamesWithRecursive(buildsToDo, baseDir, timeStamp, version, versionName, onCompleteCallback, htmlPerBuild = 1, noFolderCancelled = []) {
    if (buildsToDo.length === 0) {
      const message = noFolderCancelledMessage(noFolderCancelled);
      if (message) props.createSnackbar?.(message, "warning", false);
      onCompleteCallback();
    } else {
      const buildRecord = buildsToDo.shift();
      fetch(getServerUri("version/buildGame"), {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken"),
          baseDir,
          buildRecord: JSON.stringify(buildRecord),
          timeStamp,
          gameTitle: exportGameTitle,
          baseTitle: props.selectedBase.title,
          version: JSON.stringify(version),
          versionName,
          buildProfileData: JSON.stringify(props.userCompany?.buildProfileData || {}),
        }),
      }).then((response) => {
        if (response.status === 200) {
          incrementHTMLDownloadedCount(htmlPerBuild);
          response
            .json()
            .catch(() => ({}))
            .then((body) => {
              noFolderCancelled.push(...(body?.noFolderCancelledNetworks || []));
              buildGamesWithRecursive(buildsToDo, baseDir, timeStamp, version, versionName, onCompleteCallback, htmlPerBuild, noFolderCancelled);
            });
        } else {
          // The server refused or failed this build (e.g. BUILD_PROFILE_MISSING).
          // Stop here and show why — the remaining builds would fail the same way.
          response
            .json()
            .then((body) => body?.detail || body?.message || DOWNLOAD_ERROR_MESSAGE)
            .catch(() => DOWNLOAD_ERROR_MESSAGE)
            .then((message) => {
              console.error("buildGame failed:", message);
              setError(message);
              setIsBuilding(false);
              props.setIsDownloadingPlayable(false);
            });
        }
      });
    }
  }

  function downloadPlayableOrdered(index, toDropbox = false, dropboxFolder = "") {
    const selectedVersionInfo = selectedVersionsInfos[index];

    if (_.isNil(selectedVersionInfo)) {
      return;
    }

    setDownloadedVersionCount(() => index);
    // setDownloadedVersionCount((prevDownloadedVersionCount) => {
    //   console.log({prevDownloadedVersionCount});
    //   return prevDownloadedVersionCount;
    // });

    let networkArray = selectedVersionInfo.networks; //Array.from(totalSet);
    console.info("networks: " + JSON.stringify(networkArray));
    fetch(getServerUri("version/preBuildGame"), {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        versionID: String(selectedVersionInfo.versionID),
        networks: networkArray,
        languages: selectedVersionInfo.languages,
        bundleLang: String(bundleLang),
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          response
            .json()
            .then((dataPreBuild) => {
              // console.log({ dataPreBuild });
              const buildsToDo = _.clone(dataPreBuild.buildsToDo);
              if (buildsToDo.length < 1) {
                console.error("There is no build to do");
                return;
              }
              const versionName = dataPreBuild.version.title.replaceAll(" ", "_");
              const baseDir = dataPreBuild.baseDir;
              const timeStamp = dataPreBuild.timeStamp;
              const version = dataPreBuild.version;
              const htmlPerBuild = 1;
              buildGamesWithRecursive(buildsToDo, baseDir, timeStamp, version, versionName, () => {
                fetch(getServerUri("version/uploadGame"), {
                  method: "POST",
                  headers: {
                    "content-type": "application/x-www-form-urlencoded",
                  },
                  body: new URLSearchParams({
                    accessToken: localStorage.getItem("session.accessToken"),
                    baseDir,
                    baseID: dataPreBuild.baseID,
                    companyName: dataPreBuild.companyName,
                    gameID: dataPreBuild.gameID,
                    requestedSupportedLanguages: JSON.stringify(dataPreBuild.requestedSupportedLanguages),
                    requestedSupportedNetworks: JSON.stringify(dataPreBuild.requestedSupportedNetworks),
                    bundleLang: String(bundleLang),
                    timeStamp,
                    versionName,
                    buildProfileData: JSON.stringify(props.userCompany?.buildProfileData || {}),
                    gameTitle: exportGameTitle,
                    baseTitle: props.selectedBase.title,
                    deliverToDropbox: String(toDropbox),
                    ...(dropboxFolder ? { dropboxFolder } : {}),
                    // usage analytics: which version, from which dialog
                    versionID: String(version._id),
                    exportSource: "multiple",
                  }),
                }).then((response) => {
                  if (response.status === 200) {
                    response.json().then((obj) => {
                      if (_.has(obj, "completion")) {
                        console.info("Progress Received: ", obj);
                      } else if (_.has(obj, "file")) {
                        // Through the snackbar: this dialog closes itself once
                        // the last version of the batch is done.
                        if (obj.dropbox) props.createSnackbar?.(obj.dropbox, "info", false);
                        setButtonText("Download");

                        if (selectedVersionsInfos[selectedVersionsInfos.length - 1] === selectedVersionInfo) {
                          setIsBuilding(false);
                          props.setIsDownloadingPlayable(false);
                          props.setIsDownloadDialogOpen(false);
                          resetDownloadVersionSettings();
                        }

                        updatePlayableCounterWithOneVersion(selectedVersionInfo, () => {
                          // A submitted export went to Dropbox; nothing should
                          // land in the person's Downloads folder as well.
                          if (!toDropbox) window.location = obj.file;

                          setTimeout(() => {
                            downloadPlayableOrdered(index + 1, toDropbox, dropboxFolder);
                          }, 100);
                        }).catch((err) => {
                          console.log(err);
                        });
                      }
                    });
                  } else {
                    props.setIsDownloadingPlayable(false);
                    response
                      .json()
                      .then((object) => {
                        setError("Server did not process the request");
                        console.log("non 200 response:");
                        console.dir(object);

                        resetDownloadVersionSettings();
                      })
                      .catch((err) => {
                        setError(DOWNLOAD_ERROR_MESSAGE);
                        console.log("can't parse response as json", err);
                      });
                  }
                });
              }, htmlPerBuild);
            })
            .catch((err) => {
              props.setIsDownloadingPlayable(false);
              setError("Server did not process the request");
              setError(err);
              console.log(err);
            });
        } else {
          props.setIsDownloadingPlayable(false);
          response
            .json()
            .then((object) => {
              setError("Server did not process the request");
              console.log("non 200 response:");
              console.dir(object);

              resetDownloadVersionSettings();
            })
            .catch(() => {
              setError(DOWNLOAD_ERROR_MESSAGE);
              console.log("can't parse response as json");
            });
        }
      })
      .catch((err) => {
        props.setIsDownloadingPlayable(false);
        setError("Could not send request to server");
        console.error("FETCH ERROR");
        console.error(err);
      });
  }

  function getCurrentPlayableCount(userCompany) {
    const monthlyPlayableCount = _.get(
      props.plans[props.getPlanIndex(_.get(props, "userCompany.subscription.currentPlan"))],
      "numberOfPlayables"
    );
    let monthlyCreatedPlayables = _.get(
      userCompany?.subscription.periods[userCompany?.subscription.periods.length - 1],
      "monthlyCreatedPlayables"
    );

    const currentPlayableLimit = monthlyPlayableCount - monthlyCreatedPlayables;

    setCurrentPlayableCount(currentPlayableLimit);
    setCreditLeft(currentPlayableLimit);
  }

  function updatePlayableCounterWithOneVersion(selectedVersionInfo, onCompleteCallback) {
    const networksSize = selectedVersionInfo.networks?.length || 0;
    const selectedLanguagesSize = selectedVersionInfo.languages?.length || 0;
    const consumedPlayables = bundleLang ? networksSize : networksSize * selectedLanguagesSize;

    if (consumedPlayables <= 0) {
      onCompleteCallback();
      return Promise.resolve();
    }

    return incrementCompanyUsage(_.get(props.userCompany, "_id"), { monthlyCreatedPlayables: consumedPlayables })
      .then((newCompany) => {
        props.setUserCompany(newCompany);

        if (selectedVersionsInfos[selectedVersionsInfos.length - 1] == selectedVersionInfo) {
          getCurrentPlayableCount(newCompany);
        }
      })
      .catch((err) => {
        console.log("createdPlayables update failed: " + (err && err.message));
      })
      // The build is already delivered; a missed count must not hold it back.
      .then(() => onCompleteCallback());
  }

  function getSelectedVersionName() {
    if (props.versionRename !== "") {
      return props.versionRename;
    } else {
      return versionNames.filter((versionName) => selectedVersions[versionIndex] == versionName.key)[0]?.versionName;
    }
  }

  function getNetworkName() {
    const networks = selectedVersionsInfos.filter(
      (selectedVersionInfo) => selectedVersionInfo.versionID == selectedVersions[versionIndex]
    )[0]?.networks;
    const networkInfo = networkViews.filter((network) => networks[0] == network.name)[0];

    return networkInfo?.caption;
  }

  function calculateSelectedVersionSize(selectedVersionInfos) {
    selectedVersionInfos.forEach((selectedVersion) => {
      const isSelectedVersionSizeCalculated = versionSizes.some(
        (versionSize) => versionSize.versionID === selectedVersion
      );

      if (!isSelectedVersionSizeCalculated) {
        const versionInfo = props.versions.filter((version) => version._id === selectedVersion)[0];

        getVersionSizes(versionInfo);
      }
    });
  }

  if (props.selectedBase == null) {
    window.location.reload();
  }
  if (!props.selectedVersion === undefined) return null;

  const currentPlanType = _.get(props, "userCompany.subscription.currentPlan");
  const isEnterprise = !_.isNil(currentPlanType) && currentPlanType === _.get(props.plans[2], "type");

  return (
    <>
      <span ref={versionNameMeasureRef} className={classes.hiddenVersionNameMeasure}>
        {longestVersionName}
      </span>
      <Dialog open={props.isOpen} onClose={props.onClose}>
        <StyledDialogTitle>DOWNLOAD CREATIVE</StyledDialogTitle>

        {!loadingCompleted && (
          <div className={classes.loadingIcon}>
            <CircularProgress
              color={"secondary"}
              style={{ textAlign: "center", width: "50px", height: "50px" }}
            ></CircularProgress>
            <Typography style={{ textAlign: "center", marginTop: "20px", marginLeft: "10px" }}>{"Loading..."}</Typography>
          </div>
        )}
        {loadingCompleted && (
          <div>
            {loadingCompleted}
            <Card className={classes.downloadDialogCard}>
              <CardContent style={{ marginTop: "10px" }}>
                <InputLabel id="select-version-label" className={classes.inputLabel}>
                  Select Version
                </InputLabel>

                <Select
                  multiple
                  labelId="select-version-label"
                  IconComponent={StyledDopDownIcon}
                  input={<Input />}
                  className={classes.versionSelector}
                  MenuProps={menuProps}
                  renderValue={() => {
                    if (selectedVersions.length === 1) {
                      return getSelectedVersionName();
                    } else if (selectedVersions.length > 1) {
                      return "Multiple Versions";
                    } else if (selectedVersions.length === 0) {
                      return "Select Versions";
                    }
                  }}
                  onChange={(event) => {
                    setSelectedVersions(event.target.value);
                    calculateSelectedVersionSize(event.target.value);
                    event.target.value.forEach((value) => {
                      let newSelectedVersions = [...selectedVersionsInfos];

                      const getCurrentSelectedVersionInfo = newSelectedVersions.filter(
                        (version) => version.versionID == value
                      );

                      if (getCurrentSelectedVersionInfo.length == 0) {
                        newSelectedVersions.push({ versionID: value, languages: ["en"], networks: [] });
                        setSelectedVersionsInfos(newSelectedVersions);
                      }
                    });
                  }}
                  value={selectedVersions}
                >
                  {versionNames.map((versionInfo) => {
                    const versionName = versionInfo.versionName;
                    const key = versionInfo.key;
                    return (
                      <MenuItem key={key} value={key}>
                        <Checkbox checked={selectedVersions.indexOf(key) > -1} />
                        <div
                          className={classes.versionNameWrapper}
                          title={versionName}
                          onScroll={syncVersionNameScroll}
                          ref={registerVersionNameRef(key)}
                        >
                          <span
                            className={classes.versionNameListItem}
                            style={
                              maxVersionNameWidth
                                ? { width: `${maxVersionNameWidth}px` }
                                : undefined
                            }
                          >
                            {versionName}
                          </span>
                        </div>
                      </MenuItem>
                    );
                  })}
                </Select>

                {isGameTitleEditable && (
                  <div style={{ marginTop: "15px" }}>
                    <InputLabel htmlFor="export-game-title" className={classes.inputLabel}>
                      Game Title
                    </InputLabel>
                    <Input
                      id="export-game-title"
                      className={classes.versionSelector}
                      value={gameTitleOverride}
                      placeholder={props.selectedGame?.title}
                      onChange={(event) => setGameTitleOverride(event.target.value)}
                    />
                  </div>
                )}
              </CardContent>
            </Card>
            <Card className={classes.downloadDialogCard}>
              <Typography
                style={{
                  width: "440px",
                  fontSize: "20px",
                  textAlign: "center",
                  fontFamily: "Helvetica",
                  marginTop: "5px",
                }}
              >
                {"Selected Version"}
              </Typography>

              <CardContent
                style={{
                  textAlign: "center",
                  margin: "20px 0px 20px 0px", //top, right, bottom, left
                  padding: 0,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "57.5px",
                    height: "70px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    name="leftIcon"
                    style={{ display: arrowButtonsVisibility("left") ? "flex" : "none", padding: 0 }}
                    onClick={() => {
                      setVersionIndex(versionIndex - 1);
                    }}
                  >
                    <ArrowLeftRoundedIcon fontSize="large" style={{ width: "55px", height: "55px" }} />
                  </IconButton>
                </div>
                <div
                  style={{
                    width: "325px",
                    height: "70px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Tooltip title={getSelectedVersionName() || ""} aria-label="versionName">
                    <StyledChip label={getSelectedVersionName()} variant="outlined" />
                  </Tooltip>
                </div>
                <div
                  style={{
                    width: "57.5px",
                    height: "70px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    name="rightIcon"
                    style={{ display: arrowButtonsVisibility("right") ? "flex" : "none", padding: 0 }}
                    onClick={() => {
                      setVersionIndex(versionIndex + 1);
                    }}
                  >
                    <ArrowRightRoundedIcon fontSize="large" style={{ width: "55px", height: "55px" }} />
                  </IconButton>
                </div>
              </CardContent>

              <ThemeProvider theme={darkTheme}>
                <CardContent
                  style={{
                    marginBottom: 15,
                  }}
                >
                  <InputLabel id="select-language-label" className={classes.inputLabel}>
                    Select Language
                  </InputLabel>

                  <Select
                    multiple
                    disabled={bundleLang}
                    labelId="select-language-label"
                    IconComponent={StyledDopDownIcon}
                    input={<Input />}
                    className={classes.versionSelector}
                    renderValue={() => {
                      const currentSelectedVersionLanguages = getCurrentSelectedVersionLanguageInfos();
                      if (currentSelectedVersionLanguages.length === 1) {
                        return defaultLanguage();
                      } else if (currentSelectedVersionLanguages.length > 1) {
                        const selectedVersionLanguages = selectedVersionLanguagesFunction();
                        let languages = "";

                        currentSelectedVersionLanguages.forEach((language) => {
                          const languageCaption = selectedVersionLanguages.filter(
                            (versionLanguage) => versionLanguage.key === language
                          )[0]?.title;

                          languages += languageCaption + ", ";
                        });

                        return languages;
                      } else if (currentSelectedVersionLanguages.length === 0) {
                        return "Select Languages";
                      }
                    }}
                    onChange={(event) => {
                      selectLanguages(event.target.value);
                    }}
                    value={getCurrentSelectedVersionLanguageInfos()}
                  >
                    <MenuItem key="all" value="all">
                      <Checkbox
                        checked={allLanguagesSelected}
                        onChange={(event) => {
                          if (event.target.checked === true) {
                            const allLanguages = selectedVersionLanguagesFunction().map((language) => language.key);
                            selectLanguages(allLanguages);
                            setAllLanguagesSelected(true);
                          } else if (event.target.checked === false) {
                            selectLanguages([]);
                            setAllLanguagesSelected(false);
                          }
                        }}
                      />
                      <ListItemText primary={"All Languages"} />
                    </MenuItem>
                    {selectedVersionLanguagesFunction().map((selectedLanguage) => {
                      const languageName = selectedLanguage.title;
                      const key = selectedLanguage.key;
                      return (
                        <MenuItem key={key} value={key}>
                          <Checkbox checked={getCurrentSelectedVersionLanguageInfos().indexOf(key) > -1} />
                          <ListItemText primary={languageName} />
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {supportsLangBundle && (
                    <div style={{ display: "flex", alignItems: "center", marginTop: "8px" }}>
                      <Checkbox
                        checked={bundleLang}
                        onChange={(event) => toggleBundleLang(event.target.checked)}
                        style={{ color: "#4eabb1", paddingLeft: 0 }}
                      />
                      <Tooltip
                        title="Embed every edited language into a single HTML and auto-select by device language at runtime."
                        aria-label="bundleLang"
                      >
                        <Typography style={{ fontFamily: "Helvetica", fontSize: "14px" }}>
                          {"Bundle all languages into one HTML"}
                        </Typography>
                      </Tooltip>
                    </div>
                  )}
                </CardContent>
              </ThemeProvider>
              <ThemeProvider theme={darkTheme}>
                <CardContent>
                  <InputLabel id="select-network-label" className={classes.inputLabel}>
                    Select Network
                  </InputLabel>
                  <Select
                    multiple
                    labelId="select-network-label"
                    IconComponent={StyledDopDownIcon}
                    input={<Input />}
                    className={classes.versionSelector}
                    label="Select Network"
                    renderValue={() => {
                      const currentSelectedNetworks = getCurrentSelectedVersionNetworkInfos();
                      if (currentSelectedNetworks.length === 1) {
                        return getNetworkName();
                      } else if (currentSelectedNetworks.length > 1) {
                        const selectedVersionNetworks = selectedVersionNetworksFunction();
                        let networks = "";

                        currentSelectedNetworks.forEach((network) => {
                          const networkCaption = selectedVersionNetworks.filter(
                            (versionNetwork) => versionNetwork.name === network
                          )[0]?.caption;

                          networks += networkCaption + ", ";
                        });

                        return networks;
                      } else if (currentSelectedNetworks.length === 0) {
                        return "Select Network";
                      }
                    }}
                    onChange={(event) => {
                      changeNetwork(event.target.value);
                    }}
                    value={getCurrentSelectedVersionNetworkInfos()}
                  >
                    {networkViews.map((selectedNetwork) => {
                      const networkName = selectedNetwork.caption;
                      const key = selectedNetwork.name;
                      return (
                        <MenuItem key={key} value={key}>
                          <Checkbox checked={getCurrentSelectedVersionNetworkInfos().indexOf(key) > -1} />
                          <ListItemText primary={networkName} />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </CardContent>
              </ThemeProvider>
              <CardContent
                style={{
                  textAlign: "center",
                  margin: 0,
                  padding: 5,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    textOverflow: "ellipsis",
                    width: "400px",
                    overflow: "hidden",
                    textAlign: "right",
                    fontFamily: "Helvetica",
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  {getCurrentVersionSize()}
                </Typography>
              </CardContent>
            </Card>

            <Card className={classes.downloadDialogCard}>
              <CardContent
                style={{
                  textAlign: "center",
                  margin: 0,
                  padding: 5,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  lineHeight: "0.75",
                }}
              >
                <div className={classes.htmlCreditTypography}>
                  <Typography
                    style={{
                      textAlign: "left",
                      marginLeft: "10px",
                      color: "#9bcec0",
                      visibility: isEnterprise ? "hidden" : "visible",
                    }}
                  >
                    {"Current Credit"}
                  </Typography>
                </div>
                <div className={classes.htmlCreditTypography}>
                  <Typography style={{ textAlign: "center", color: "#9bcec0" }}>{"Html Count"}</Typography>
                </div>
                <div className={classes.htmlCreditTypography}>
                  <Typography
                    style={{
                      textAlign: "right",
                      marginRight: "10px",
                      color: "#9bcec0",
                      visibility: isEnterprise ? "hidden" : "visible",
                    }}
                  >
                    {"Credit Left"}
                  </Typography>
                </div>
              </CardContent>

              <CardContent
                style={{
                  textAlign: "center",
                  margin: 0,
                  marginTop: "-10px",
                  display: "flex",
                  padding: 5,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  lineHeight: "0.75",
                }}
              >
                <div className={classes.htmlCreditTypography}>
                  <Typography style={{ textAlign: "left", marginLeft: "10px", visibility: isEnterprise ? "hidden" : "visible" }}>
                    {currentPlayableCount}
                  </Typography>
                </div>
                <div className={classes.htmlCreditTypography}>
                  <Typography style={{ textAlign: "center" }}>{htmlCount}</Typography>
                </div>
                <div className={classes.htmlCreditTypography}>
                  <Typography style={{ textAlign: "right", marginRight: "10px", visibility: isEnterprise ? "hidden" : "visible" }}>
                    {creditLeft}
                  </Typography>
                </div>
              </CardContent>
            </Card>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginBottom: "25px",
                  marginTop: "9px",
                  width: "46%",
                }}
              >
                <Typography
                  style={{
                    textAlign: "left",
                    display: isBuilding ? "flex" : "none",
                    marginTop: "8px",
                    marginLeft: "30px",
                    whiteSpace: "pre-line",
                  }}
                >
                  {`Progress...
                Version Remaining: ${downloadedVersionCount}/${selectedVersionsInfos.length}
                HTML Remaining: ${downloadedHTMLCount}/${htmlCount}
                ETA: ${ETAMinutes} minute(s)`}
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "row",
                  marginTop: "41px",
                  width: "54%",
                }}
              >
                <CircularProgress
                  color={"secondary"}
                  style={{ textAlign: "center", display: isBuilding ? "flex" : "none" }}
                ></CircularProgress>
              </div>
            </div>

            <div
              style={{
                display: !isBuilding ? "flex" : "none",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: "25px",
                marginTop: "9px",
              }}
            >
              <StyledButton
                name="download"
                disabled={isBuilding}
                style={{ display: !isBuilding ? "flex" : "none" }}
                onClick={() => downloadGame(false)}
              >
                <DownloadIcon style={{ width: "35px", height: "50px", marginRight: "5px" }} />
                {buttonText}
              </StyledButton>
              {canDeliverDropbox && (
                <SubmitButton
                  name="submitToDropbox"
                  variant="outlined"
                  size="small"
                  disabled={isBuilding}
                  onClick={() => canStartExport() && setIsSubmitConfirmOpen(true)}
                >
                  Submit to Dropbox
                </SubmitButton>
              )}
            </div>

            <Typography style={{ textAlign: "center" }}>{error}</Typography>
          </div>
        )}
      </Dialog>

      <DialogPlayableSizeWarning
        versions={sizeWarningVersions}
        toDropbox={sizeWarningToDropbox}
        onCancel={() => setSizeWarningVersions([])}
        onConfirm={() => {
          setSizeWarningVersions([]);
          startDownload(sizeWarningToDropbox, sizeWarningFolder);
        }}
      />
      <DialogDropboxSubmit
        isOpen={isSubmitConfirmOpen}
        defaultCompanyFolder={props.userCompany?.name}
        defaultGameFolder={props.selectedGame?.title}
        gameCode={exportGameTitle}
        destinationFor={(folder) =>
          dropboxDestination(buildProfileData, {
            dropboxFolder: folder,
            gameTitle: exportGameTitle,
            versionName:
              selectedVersions.length === 1
                ? (getSelectedVersionName() || props.selectedVersion?.title || "").replace(/ /g, "_")
                : "<version name>",
          })
        }
        onCancel={() => setIsSubmitConfirmOpen(false)}
        onConfirm={(folder) => {
          setIsSubmitConfirmOpen(false);
          downloadGame(true, folder);
        }}
      />
    </>
  );
}
